import { DeleteOutlined } from '@ant-design/icons';
import { Category, Document } from 'interfaces/documents';
import { useModal } from 'hooks/useModal';
import { softDeleteCategory } from 'slices/categoriesActions';
import { softDeleteDocument, refreshDocumentTreeLevels } from 'slices/documentsActions';
import { useAppDispatch } from 'utilities/hooks';
import { containingFolderOf } from 'utilities/documentTree';
import { MenuItemType } from 'antd/es/menu/interface';

export const Delete = (
    row: Category | Document,
    fetchData: () => void
): MenuItemType => {
    const dispatch = useAppDispatch();
    const { openModal } = useModal();

    const deleteItem = async () => {
        if (!row) return;

        try {
            if ((row as Category).type === 'category') {
                await dispatch(softDeleteCategory((row as Category).id)).unwrap();
            } else {
                await dispatch(softDeleteDocument((row as Document).id)).unwrap();
            }
            dispatch(refreshDocumentTreeLevels([containingFolderOf(row)]));
            fetchData();
        } catch (error) {
            console.error('Failed to delete item:', error);
        }
    };

    return {
        key: 'Delete',
        label: 'Delete',
        onClick: () => {
            openModal('confirmationModal', {
                text: 'Are you sure want to delete item?',
            }, {
                onConfirm: () => {
                    deleteItem();
                }
            });
        },
        icon: <DeleteOutlined />,
    };
}